import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import getFormatedDate from "../../Utils/DateFormatter";
import closeBtn from "../../assets/close-btn.png";
import defaultupload_fb from "../../assets/default-fb.png";
import { userId, getUser } from "../../Utils/LocalStorage";

const ProductModal = ({
  flag,
  product_name,
  product_image,
  availableDat,
  endDat,
  product_value,
  product_price,
  description,
  tnc,
  business_name,
  ...props
}) => {
  const availableDate = availableDat ? getFormatedDate(availableDat) : "";
  const endDate = endDat ? getFormatedDate(endDat) : "";
  const [offerPercent, setOfferPercent] = useState(null);
  const BusinessUserData = getUser();
  const SlUserName = userId();
  const Bu_Name = BusinessUserData
    ? BusinessUserData.business_name
    : SlUserName;

  useEffect(() => {
    if ((product_value, product_price)) {
      const exactValue =
        ((product_value - product_price) / product_value) * 100;
      const percentValue = exactValue.toFixed(2);
      const finalValue = percentValue.endsWith(".00")
        ? percentValue.split(".")[0]
        : percentValue;

      setOfferPercent(finalValue);
    }
  }, [product_value, product_price]);
  return (
    <div>
      {" "}
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modalMain create-vou-modal product-modal"
      >
        {/* <Modal.Header closeButton></Modal.Header> */}

        <Modal.Body>
          <img
            src={closeBtn}
            onClick={() => props.onHide()}
            className="close-btn"
            alt=""
            height={20}
            width={20}
          />
          <Row className="pointer-events-none">
            <Col md={6}>
              <img
                src={product_image||defaultupload_fb}
                alt="Voucher Image"
                className="image-voucher-div"
              />
            </Col>
            <Col md={6}>
              <div className="TCdetails">
                <h1 className="voucher-name">{product_name}</h1>
                <h2 className="voucher_by_name">By {business_name}</h2>
                <div className="available-voucher">
                  <p className="voucher-available">
                    Available Until : {availableDate}
                  </p>
                </div>
                {flag === "Voucher" && (
                  <div className="voucher-price">
                    <p className="text-decoration-line-through voucher-value">
                      ${product_value}
                    </p>
                    <p className="TCdollar voucher-discount">
                      ${product_price}
                    </p>
                    <div className="voucher_offer">
                      <p className="vocher-offer-text">{offerPercent}% off</p>
                    </div>
                  </div>
                )}
                <div>
                  <span className="TC-about about-deal">About this deal :</span>
                  <div>
                    <p
                      className="about-des"
                      style={{ color: "black" }}
                      dangerouslySetInnerHTML={{
                        __html: description,
                      }}
                    ></p>
                  </div>
                </div>

                <div className="purchase-div mt-3">
                  <button className="TCbuynow purchase-buy-now" disabled>
                    {flag === "Voucher" ? "Buy Now" : "Download"}
                  </button>
                  <button className="share-deal-now" disabled>
                    Share This Deal
                  </button>
                </div>
              </div>
            </Col>
          </Row>

          <div className="shdow_show">
            <Col className="tab-div" md={12}>
              <Tabs
                defaultActiveKey="home"
                id="fill-tab-example"
                className="mb-3"
                fill
              >
                <Tab eventKey="home" title="Terms & Conditions" disabled>
                  <ul>
                    <li>
                      {flag}&nbsp;expiration date: {endDate}
                    </li>
                    {tnc &&
                      tnc.length > 0 &&
                      tnc.map((item) => {
                        return <li>{item}</li>;
                      })}
                  </ul>
                </Tab>
                <Tab eventKey="profile" title="About" disabled></Tab>
                <Tab eventKey="longer-tab" title="Contact" disabled></Tab>
                <Tab eventKey="contact" title="Location" disabled></Tab>
              </Tabs>
            </Col>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProductModal;
